
import _concat from 'lodash/concat'
import _uniq from 'lodash/uniq'
import { setObjects } from '../helpers'

const initialState = () => ({
    storage: { },
})

const mutations = {
    ADD_SCHOOLS (state, schools) {
        setObjects(schools, state.storage, { groups: [], tickets: [] })
    },
    SET_GROUPS_FOR_SCHOOL (state, groups, schoolId) {
        state.storage[schoolId].groups = groups
    },
    APPEND_GROUP_TO_SCHOOL (state, group, schoolId) {
        state.storage[schoolId].groups = _uniq(_concat(state.storage[schoolId].groups, group.id))
    },
    ADD_SCHOOL_TICKET_TO_SCHOOL (state, schoolId, schoolTicketId) {
        const school = state.storage[schoolId]

        if ( school.tickets.indexOf(schoolTicketId) === -1) {
            school.tickets.push(schoolTicketId)
        }

    },
    RESET_SCHOOL_TICKETS (state, schoolId) {
        state.storage[schoolId].tickets = []
    }
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/schools.js